<template>
  <tree-list-layout-adapter :left-panel-enable="false" :right-top-panel-enable="false">
    <template #datatable>
      <div style="padding-top:24px;" class="h100">
        <GeneralTable
          ref="customTable"
          code="REPORT_CONFIG_LIST"
          :loading="tableLoading"
          :batch-delete="true"
          :version="2"
          :data="tableData"
          :pagination="pagination"
          :columns="tableColumns"
          @refresh="handleRefresh"
          @handleSizeChange="handlePaginationChange"
          @handleCurrentChange="handlePaginationChange"
          @batchDeleteData="deleteData"
        >
          <template #operation="{ scope }">
            <el-button
              type="text"
              class="btn__text--no-padding"
              @click="handleModalShow(scope.row, 'edit')"
            >
              {{ $t('public.edit') }}
            </el-button>
            <el-button
              type="text"
              class="btn__text--no-padding"
              @click="handleModalShow(scope.row, 'details')"
            >
              详情
            </el-button>
            <el-button
              type="text"
              class="btn__text--no-padding btn__text--red"
              @click="handleDeleteShow(scope.row)"
            >
              {{ $t('public.delete') }}
            </el-button>
          </template>
          <div slot="tableSearchContent">
            <div class="search">
              <el-form
                :inline="true"
                :model="searchForm"
                class="demo-form-inline"
                @submit.native.prevent
              >
                <el-form-item>
                  <el-input
                    v-model="searchForm.value"
                    clearable
                    style="width: 316px"
                    placeholder="请输入报表编码或者名称"
                    @keyup.enter.native="handleSearch"
                  >
                    <div slot="suffix" class="search-input__icon--search">
                      <svg-icon
                        icon-class="search"
                        class="search-icon cursor-p"
                        @click="handleSearch"
                      ></svg-icon>
                    </div>
                  </el-input>
                </el-form-item>
                <el-form-item class="float-right" style="margin-right: 0">
                  <el-button
                    icon="el-icon-circle-plus-outline"
                    type="primary"
                    @click="handleModalShow(null, 'add')"
                  >
                    新增报表
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </GeneralTable>
        <!-- /表格 -->
      </div>

      <!-- 表格删除确认框 -->
      <delete-dialog
        layout="left"
        :visible.sync="deleteDialogVisible"
        :content="deleteContent"
        :loading.sync="deleteLoading"
        @confirm="handleDeleteConfirm"
      />
      <!-- /表格删除确认框 -->

      <!-- 新增|编辑弹框 -->

      <!-- /新增|编辑弹框 -->
    </template>
  </tree-list-layout-adapter>
</template>

<script>
import DeleteDialog from "@/components/common/Dialogs/DeleteDialog";
import { updatePageNum } from "@/utils";
import TreeListLayoutAdapter from "@/layout/components/TreeListLayoutAdapter";
import reportConfigApi from "@/api/report-config/index";
export default {
  name: "ReportConfigList",
  components: {
    DeleteDialog,
    TreeListLayoutAdapter
  },
  data() {
    return {
      searchForm: {
        value: ""
      },
      tableLoading: false,
      tableColumns: [
        {
          label: "报表编码",
          key: "reportCode",
          width: "150",
          fixed: false
        },
        {
          label: "报表名称",
          key: "reportName",
          width: "150",
          fixed: false
        },
        {
          label: "描述",
          key: "description",
          width: "150",
          fixed: false
        },
        {
          label: "SQL表达式",
          key: "originalSql",
          width: "auto",
          minWidth: "200",
          fixed: false
        }
      ],
      tableData: [],
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      dialogFormVisible: false,
      formData: {},
      deleteDialogVisible: false,
      deleteLoading: false,
      deleteContent: {
        title: this.$t("common.popupDelete.title"),
        description: this.$t("common.popupDelete.description")
      },
      uploadData: {},
      deleteRows: []
    };
  },
  watch: {
    "searchForm.value"(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.handleSearch();
      }
    }
  },
  created() {
    this.getList();
  },
  methods: {
    handleRefresh() {
      this.$emit("refresh");
    },
    // 获取列表数据
    getList() {
      this.tableData = [];
      this.tableLoading = true;
      const params = {
        page: this.pagination.pageNum,
        size: this.pagination.pageSize,
        search: this.searchForm.value
      };
      reportConfigApi.getDynamicReportlist(params)
        .then(res => {
          this.tableLoading = false;
          if (res.success) {
            const { data } = res;
            if (data) {
              const { records = [], total = 0 } = data;
              this.tableData = records;
              this.pagination.total = Number(total);
            }
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // 搜索
    handleSearch() {
      this.pagination.pageNum = 1;
      this.getList();
    },
    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.getList();
    },
    // 添加|编辑
    handleModalShow(data = {}, type) {
      switch (type) {
        case "add":
          this.$router.push({
            path: "/report-config/report-config-add"
          });
          break;
        case "edit":
          console.log(data);
          this.$router.push({
            path: "/report-config/report-config-edit",
            query: { id: data.id }
          });
          break;
        case "details":
          this.$router.push({
            path: "/report-config/report-config-details",
            query: { id: data.id }
          });
          break;
      }
    },
    // 删除
    handleDeleteShow(row) {
      this.deleteRows = [row.id];
      this.deleteDialogVisible = true;
    },
    // 多条删除
    deleteData(data) {
      this.deleteRows = data.map(res => res.id);
      this.deleteDialogVisible = true;
    },
    // 删除提交
    handleDeleteConfirm() {
      this.deleteLoading = true;
      reportConfigApi.deleteDynamicReport({ keys: this.deleteRows })
        .then(res => {
          this.deleteLoading = false;
          if (res.success) {
            this.deleteDialogVisible = false;
            this.$message.success(this.$t("public.successfullyDeleted"));
            updatePageNum([this.deleteRows], this.pagination);
            this.getList();
          }
        })
        .catch(() => {
          this.deleteLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
